// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=ChatConfigApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=1d2784ad71d4d9064edec5e7a894a536231614bf|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseChatConfigResponseFromJSON } from '../../../parsers/ChatConfigResponse';
import { parseChatContextToJSON } from '../../../parsers/ChatContext';

export class ChatConfigApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 ChatConfigAccessAuth</p>
   *
   * @tags ChatConfigApi
   * @name ChatConfigApiGetConfig
   * @summary Get initial chat configuration based on context
   * @request POST:/config
   * @secure
   */
  getConfig(
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/config`,
        route: '/config',
        method: 'POST',
        body: parseChatContextToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseChatConfigResponseFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function ChatConfigApi_Factory(t) { return new (t || ChatConfigApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: ChatConfigApi, factory: ChatConfigApi.ɵfac, providedIn: 'root' });
}
